<template>
  <header>
    <b-navbar toggleable="lg" type="dark" class="pt-0 pb-0 bg-blue">
      <b-navbar-toggle v-if="isLogged" target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand href="#/"><img style="width:100px" src="../assets/logo_small_white.png"></b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        
        <b-navbar-nav>
          <router-link size="sm" v-if="isLogged && permiso('4586B73F')" class="nav-link" to="/estudiantes" >Estudiantes</router-link>
          <router-link size="sm" v-if="isLogged && permiso('8A28EE41')" class="nav-link" to="/docentes" >Docentes</router-link>
          <router-link size="sm" v-if="isLogged && permiso('B2903DC1')" class="nav-link" to="/salones" >Salones</router-link>

          <b-nav-item-dropdown text="Académico" v-if="isLogged">
            <b-dropdown-item v-if="isLogged && permiso('19E70E2C')">
              <router-link  class="dark" to="/cursos" >Cursos</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('B7A9DE95')">
              <router-link  class="dark" to="/examenes" >Examenes</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          
          <b-nav-item-dropdown text="Programador" v-if="isLogged">
            <b-dropdown-item v-if="isLogged && permiso('8D24244B')">
                <router-link  type="dark" to="/programador">Clases</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('023AB260')">
              <router-link  type="dark" to="/tutoria">Tutorias</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          
          <b-nav-item-dropdown text="Admin" v-if="isLogged">
            <b-dropdown-item v-if="isLogged && permiso('42A34371')">
              <router-link  type="dark" to="/usuarios" >Usuarios</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('4F40D01B')">
              <router-link  type="dark" to="/grupos" >Grupos</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('80E96183')">
              <router-link  type="dark" to="/permisos" >Permisos</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('E4D2DDE5')">
              <router-link  type="dark" to="/cierres" >Cierres</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('2360680B')">
              <router-link  type="dark" to="/banners/lista" >Banners</router-link>
            </b-dropdown-item >
            
            <b-dropdown-item v-if="isLogged && permiso('E1D33839')">
              <router-link  type="dark" to="/cacelacionMasiva" >Cancelación masiva</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('4B195124')">
              <router-link  type="dark" to="/activacion-masiva" >Activar/desactivar masivo</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('10F6CF17')">
              <router-link  type="dark" to="/tema/masivo" >Temas Masivos</router-link>
            </b-dropdown-item >
            <b-dropdown-item v-if="isLogged && permiso('EACA7E4')">
              <router-link  type="dark" to="/masivos"
               >Masivos</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown text="Reportes" v-if="isLogged">
            <!-- <b-dropdown-item v-if="isLogged && permiso('17737EC6')">
              <router-link  type="dark" to="/reportes/ocupacion" >Ocupacion</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('96EC0186')">
              <router-link  type="dark" to="/reportes/actividad" >Actividad</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('1D040A9C')">
              <router-link  type="dark" to="/reportes/consumo" >Consumo</router-link>
            </b-dropdown-item> -->
            <b-dropdown-item v-if="isLogged && permiso('11FC3E77')"> <!--  -->
              <router-link  type="dark" to="/reportes/siet" >SIET</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('E96EB087')"> <!--  -->
              <router-link  type="dark" to="/reportes/solicitud-avance" >Solicitud Avance</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('F83DCEB2')"> <!--  -->
              <router-link  type="dark" to="/reportes/encuesta-satisfaccion" >Encuesta Satisfacción</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="isLogged && permiso('8B8998F3')"> <!--  -->
              <router-link  type="dark" to="/reportes/ocupacion-docentes" >Ocupación docente</router-link>
            </b-dropdown-item>
            
            
          </b-nav-item-dropdown>

          <router-link v-if="isLogged && permiso('293B9B69')" class="nav-link" target="_blank" to="/pantalla" >Pantalla</router-link>
          <router-link v-if="isLogged && permiso('4E621462')" class="nav-link" target="_blank" to="/logistica" >Logistica</router-link>
          
        </b-navbar-nav>


        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto" v-if="isLogged">
          <router-link to="/profile" class="user-avatar mr-2" title="Mi perfil">
            <i class="fa fa-user"></i>
          </router-link>
          <b-nav-item-dropdown  right no-caret class="user-dropdown">
            <template #button-content>
              <div class="user-info-trigger">
                <div class="user-details">
                  <span class="user-name">{{ nombreUsuario }}</span>
                  <span class="user-sede" v-if="sede">
                    <i class="fa fa-map-marker"></i> {{ sede.nombre }}
                  </span>
                </div>
                <i class="fa fa-chevron-down dropdown-arrow"></i>
              </div>
            </template>
            <b-dropdown-item v-if="puedeCambiarSede" @click="iniciarCambiarSede()">
              <i class="fa fa-map-marker"></i> Cambiar sede
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click="processLogout()">
              <i class="fa fa-sign-out"></i> Cerrar Sesión
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <CambiarSedeModal ref="cambiarSedeModal"></CambiarSedeModal>

    
  </header>
</template>

<script>
  import {mapState, mapGetters, mapActions} from 'vuex';
  import CambiarSedeModal from '@/components/CambiarSedeModal';
  
  export default {
    components: {
      CambiarSedeModal
    },
    name: 'navigation',
    mounted(){
      if(this.user && !this.sede){
        this.fetchSede()    
      }
    },
    methods: {
      ...mapActions({
        logout: 'auth/logout',
        fetchSede: 'auth/fetchSede'
      }),
      processLogout () {
        this.logout().then(
          this.$router.push('/login')
        )
      },
      iniciarCambiarSede(){
        this.$refs.cambiarSedeModal.abrir()
      }
    },
    computed:{
    ...mapState({
        isLogged: state => state.auth.logged,
        user: state => state.auth.user,
        sede: state => state.auth.sede
      }),
    ...mapGetters({
        permiso: 'auth/permiso', 
      }),
      nombreUsuario() {
        if (!this.user || !this.user.data) return '';
        return `${this.user.data.primer_nombre} ${this.user.data.primer_apellido}`;
      },
      textoMiCuenta(){
        let texto =  this.user.data.primer_nombre+' '+this.user.data.primer_apellido
        if(this.sede){
          texto = texto +' en '+this.sede.nombre
        }
        return texto
      },
      puedeCambiarSede(){
        return !!(this.user && this.user.data && this.user.data.sedes_permitidas && this.user.data.sedes_permitidas.length)
      }
    }
  }
</script>

<style scoped>
.user-dropdown >>> .dropdown-toggle {
  background: transparent !important;
  border: none !important;
  padding: 0.25rem 0.75rem !important;
  display: flex !important;
  align-items: center !important;
}

.user-dropdown >>> .dropdown-toggle:hover,
.user-dropdown >>> .dropdown-toggle:focus {
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 8px;
}

.user-dropdown >>> .dropdown-toggle::after {
  display: none !important;
}

.user-info-trigger {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(255, 255, 255, 0.3);
  transition: all 0.3s ease;
}

.user-dropdown:hover .user-avatar {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: scale(1.05);
}

.user-avatar i {
  color: #ffffff;
  font-size: 1.1rem;
}

.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.3;
  max-width: 200px;
}

.user-name {
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.user-sede {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.75rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.user-sede i {
  font-size: 0.7rem;
}

.dropdown-arrow {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.7rem;
  margin-left: 0.25rem;
  transition: transform 0.3s ease;
}

.user-dropdown.show .dropdown-arrow {
  transform: rotate(180deg);
}

.user-dropdown >>> .dropdown-menu {
  border-radius: 10px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  margin-top: 0.5rem;
  min-width: 200px;
  padding: 0.5rem 0;
}

.user-dropdown >>> .dropdown-item {
  padding: 0.65rem 1.25rem;
  font-size: 0.9rem;
  color: #2c3e50;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-dropdown >>> .dropdown-item i {
  width: 18px;
  text-align: center;
  color: #0D4E8C;
}

.user-dropdown >>> .dropdown-item:hover {
  background-color: #f0f4f8;
  color: #0D4E8C;
  padding-left: 1.5rem;
}

.user-dropdown >>> .dropdown-divider {
  margin: 0.5rem 0;
  border-top-color: #e0e0e0;
}

/* Responsive */
@media (max-width: 991px) {
  .user-info-trigger {
    padding: 0.5rem 0;
  }
  
  .user-details {
    max-width: 150px;
  }
  
  .user-name {
    font-size: 0.85rem;
  }
  
  .user-sede {
    font-size: 0.7rem;
  }
  
  /* Dropdown azul para mobile */
  .user-dropdown >>> .dropdown-menu {
    background-color: #0D4E8C;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .user-dropdown >>> .dropdown-item {
    color: rgba(255, 255, 255, 0.9);
  }
  
  .user-dropdown >>> .dropdown-item i {
    color: rgba(255, 255, 255, 0.8);
  }
  
  .user-dropdown >>> .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: #ffffff;
    padding-left: 1.5rem;
  }
  
  .user-dropdown >>> .dropdown-divider {
    border-top-color: rgba(255, 255, 255, 0.2);
  }
}
</style>
